import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MediaBankFileModel } from '@fi-app/media-bank/media-bank-file.model';
import { MediaBankEditBase } from '@fi-app/media-bank/media-bank-edit-base';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

@Component({
    selector: 'fi-media-bank-names-descriptions',
    template: `
        @if (isEditMode()) {
            <fi-name-input
                [selectedLanguageId]="selectedLanguageId"
                [labelTextId]="'common.name'"
                [required]="true"
                [(ngModel)]="mediaBankFile.Names"
                name="mediabank-name"
            />
            @for (description of mediaBankFile.Descriptions; track description; let index = $index) {
                @if (isSelectedLanguage(description)) {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'common.Keywords' | fiAppText }}</mat-label>
                        <textarea
                            matInput
                            [(ngModel)]="description.Value"
                            [name]="'description-id' + description.ContentLanguageId"
                            fiAutosize="'height'"
                        >
                        </textarea>
                    </mat-form-field>
                }
            }
        }
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./media-bank-names-descriptions.component.scss'],
    host: { class: 'fi-media-bank-names-descriptions' },
    standalone: false,
})
export class MediaBankNamesDescriptionsComponent extends MediaBankEditBase {
    @Input() mediaBankFile: MediaBankFileModel;
    @Input() MediaBankFiles: MediaBankFileModel[] = [];
    @Input() selectedLanguageId: number;

    protected isEditMode(): boolean {
        return this.MediaBankFiles.length > 1 ? this.mediaBankFile.IsEditMode : true;
    }

    protected isSelectedLanguage(description: IContentLanguageLabelModel): boolean {
        return description.ContentLanguageId === this.selectedLanguageId;
    }
}
